import React from 'react'
import { Box, Typography } from '@mui/material'

export function VanityConventions() {
  return (
    <Box sx={{ mt: 1, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mb: 2 }}
      >
        Allowed characters: UPPERCASE, numbers, hyphen (-), underscore (_), dot
        (.), tilde (~)
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Standard Naming Convention:
      </Typography>
      <Typography
        variant="body2"
        sx={{
          mb: 2,
          fontWeight: 'bold',
          bgcolor: 'background.paper',
          p: 1,
          borderRadius: 1,
        }}
      >
        {
          '<Publisher&Subject>.<Common Core-State>.<Grade>(-language, if other than English)'
        }
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Examples:
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'minmax(300px, auto) max-content',
          width: 'fit-content',
          gap: 0.5,
          alignItems: 'center',
          '& > *:nth-of-type(even)': {
            pl: 2,
            borderLeft: '1px solid',
            borderColor: 'divider',
          },
        }}
      >
        <Typography variant="body2">
          OUR HS Math: Algebra 1 Common Core
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'primary.main', fontFamily: 'monospace' }}
        >
          OURM.US.A1
        </Typography>

        <Typography variant="body2">
          (OUR) EL Education, Grade 7, Curriculum 2019
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'primary.main', fontFamily: 'monospace' }}
        >
          OURE.US.G7
        </Typography>

        <Typography variant="body2">
          OpenSciEd Grade 6 Science, Florida version
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'primary.main', fontFamily: 'monospace' }}
        >
          OSES.FL.G6
        </Typography>

        <Typography variant="body2">
          OpenStax Biology, Tennessee version
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'primary.main', fontFamily: 'monospace' }}
        >
          OSXS.TN.BI
        </Typography>
      </Box>
    </Box>
  )
}
